import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { compose, mapProps } from 'recompose';
import { withAnalytic } from '@skooldio/analytics-provider/dist/Analytics/hoc';
import styled from 'styled-components';

import { viewportHeight } from 'Components/Theme/uiScale';
import { Text, Box, Flex, Icon, ICON_LIST } from 'Components/Base';
import ButtonOutlinedIcon from 'Components/ButtonOutlinedIcon';
import { getSchoolCode } from 'Domains/LESchoolData/Routing';
import { useAnalytics } from 'Libs/Analytics';
import LearningResult from 'Containers/LearningResult';
import LearningResultExporter from 'Containers/LearningResultExporter';

const getUpdateTime = () => {
  return moment().format('DD/MM/YYYY HH:mm');
};

const LearningResultPageWrapper = styled(Box)`
  border-radius: 10px;
  flex: 1 0;
  display: grid;
  grid: auto auto 1fr / 100%;
  row-gap: 16px;
  overflow: hidden;
  max-height: calc(${viewportHeight(100)} - 96px);
`;

const LearningResultPage = ({ schoolCode, onLogAction, auth: { myProfile }, ...props }) => {
  const { send } = useAnalytics();
  const { t } = useTranslation('learningResult');
  const [isFetchData, setIsFetchData] = useState(false);
  const [disabledFetch, setDisabledFetch] = useState(true);
  const [appliedFilter, setAppliedFilter] = useState({});
  const [filterSlot, setFilterSlot] = useState(null);

  const handleFilterApplied = filters => setAppliedFilter(filters);

  return (
    <LearningResultPageWrapper px={[0, null, 2, 7]} py={[0, null, 3, 5]} bg={'white'}>
      <Box>
        <Flex
          alignItems={'center'}
          justifyContent={'space-between'}
          flexWrap={'wrap'}
          style={{ position: 'relative' }}
        >
          <Flex alignItems={'center'} flexWrap={'wrap'} mb={2}>
            <Text.Title>{t('TITLE')}</Text.Title>
            <Box ml={4} ref={setFilterSlot} />
          </Flex>
          <Flex flexShrink={0} mb={2}>
            <LearningResultExporter
              disabled={disabledFetch}
              appliedFilter={appliedFilter}
              schoolCode={schoolCode}
              myProfileId={myProfile.id}
            />
            <ButtonOutlinedIcon
              textProp={{
                fontWeight: 'semibold',
              }}
              ml={2}
              lineHeight={'0.5'}
              height={'40px'}
              leftIcon={<Icon name={ICON_LIST.REFRESH} />}
              message={t('UPDATE')}
              disabled={disabledFetch}
              onClick={() => {
                onLogAction({
                  category: 'Fatch data',
                  action: `Click`,
                  label: `Click on learning result page`,
                });
                send('update', { on: 'learning_result_page' });
                setIsFetchData(true);
              }}
            />
          </Flex>
        </Flex>
        <Flex justifyContent={'flex-end'}>
          <Text.Hint
            mt={1}
            color={'timeUpdate'}
            textAlign={'right'}
            display={disabledFetch ? 'none' : 'block'}
          >
            {t('UPDATE_DESCRIPTION_TIME')} {getUpdateTime()}
          </Text.Hint>
        </Flex>
      </Box>

      <LearningResult
        isFetchData={isFetchData}
        setIsFetchData={setIsFetchData}
        setDisabledFetch={setDisabledFetch}
        onFilterApplied={handleFilterApplied}
        schoolCode={schoolCode}
        myProfileId={myProfile.id}
        filterSlot={filterSlot}
      />
    </LearningResultPageWrapper>
  );
};

export default compose(mapProps(getSchoolCode), withAnalytic)(LearningResultPage);
